import { parseWMSCapabilities } from './lib/parsers/wms/parse-wms-capabilities';
const VERSION = typeof "3.4.15" !== 'undefined' ? "3.4.15" : 'latest';
export const WMSCapabilitiesLoader = {
  id: 'wms-capabilities',
  name: 'WMS Capabilities',
  module: 'wms',
  version: VERSION,
  worker: false,
  extensions: ['xml'],
  mimeTypes: ['application/vnd.ogc.wms_xml', 'application/xml', 'text/xml'],
  testText: testXMLFile,
  options: {
    wms: {}
  },
  parse: async (arrayBuffer, options) => parseWMSCapabilities(new TextDecoder().decode(arrayBuffer), options === null || options === void 0 ? void 0 : options.wms),
  parseTextSync: (text, options) => parseWMSCapabilities(text, options === null || options === void 0 ? void 0 : options.wms)
};
function testXMLFile(text) {
  return text.startsWith('<?xml');
}
export const _typecheckWMSCapabilitiesLoader = WMSCapabilitiesLoader;
//# sourceMappingURL=wms-capabilities-loader.js.map